module.exports = __webpack_public_path__ + "img/R. Daniel Nahon.703dfac4.png";